import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: 'How do I receive the material?',
  a: 'Immediately after payment you receive an email with your download link. Access in under 5 minutes, and it works on phone, tablet and computer.'
}, {
  q: 'Is it useful if I am a new coach or already experienced?',
  a: 'Both. If you are starting out, you get the full system so you never improvise from day one. If you are experienced, it saves you planning time and adds continuity to what you already do well.'
}, {
  q: 'Are the 6 bonuses included?',
  a: 'Yes. All 6 strategic bonuses are included with the complete box set at no extra cost, free for a limited time.'
}, {
  q: 'Does it work for different age groups at the same club?',
  a: 'Yes. The 14 volumes cover U6 through U23. If you coach more than one age group, you have the complete system for all of them.'
}, {
  q: 'Is this a one-time payment?',
  a: 'Yes. $27 USD once, with lifetime access. No subscription, no upsells and no recurring charges.'
}, {
  q: 'What if it is not right for me?',
  a: '7-day money-back guarantee. If it is not what you expected we refund 100% of your money, with no forms and no justification needed.'
}, {
  q: 'How can I pay?',
  a: 'All major credit and debit cards, plus GooglePay and ApplePay. Payment is 100% secure and you are charged in your local currency.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#F4F6F2] px-5 py-14 md:py-24" data-id="element-69" data-mp="rzuels92knvm">
      <div className="max-w-3xl mx-auto" data-id="element-70" data-mp="rx88zy5qoig1">
        <h2 className="font-display uppercase text-center text-gray-900 text-[7vw] min-[430px]:text-3xl md:text-5xl leading-[1.05] mb-9 md:mb-12" data-id="element-71" data-mp="wz7bl5tnnbbx">
          Frequently asked{' '}
          <span className="text-neon-deep" data-id="element-72" data-mp="n0hrd6eadesi">questions.</span>
        </h2>

        <div className="space-y-2.5 md:space-y-3" data-id="element-73" data-mp="n1stz2vzwgi1">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="bg-white border border-gray-200" data-id="element-74" data-mp="2kv52p56tdpdl" data-mpi={i}>
                <h3 data-id="element-75" data-mp="2fw27sdkjszjc">
                  <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full px-4 py-4 md:px-6 md:py-5 flex justify-between items-center gap-3 md:gap-4 text-left hover:bg-gray-50 transition-colors" data-id="element-76" data-mp="2fxlog5a49cln">
                    <span className="font-bold text-gray-900 text-[0.9rem] md:text-lg" data-id="element-77" data-mp="33n7mgper5ls2">
                      {faq.q}
                    </span>
                    <span className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-neon/20 text-neon-deep flex items-center justify-center flex-shrink-0" data-id="element-78" data-mp="2ulzyp19v43c8">
                      {isOpen ? <Minus size={14} data-id="element-79" data-mp="1n9hhzhjq0vhw" /> : <Plus size={14} data-id="element-80" data-mp="1n5tp8km3od48" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-81" data-mp="3uu6g84sv8igb">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} className="overflow-hidden" data-id="element-82" data-mp="3us3h8v9qjezg">
                      <p className="px-4 pb-5 md:px-6 md:pb-6 pt-1 text-gray-600 text-sm md:text-base leading-relaxed" data-id="element-83" data-mp="hftcznc49r5u">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}